<template>
  <base-help-tooltip
    popover-placement="top"
  >
    <template v-slot:left>
      <h3>
        {{ labelName }}
      </h3>
    </template>
    <template v-slot:popover-body>
      <p>
        SmartMatch™ will automatically append your provided tracking string to the clickable areas when your advertisements are served.
      </p>
      <p>
        We support a wide range of tracking domains and patterns across different tracking types:
      </p>
      <ul class="p-3">
        <h6>Impression & Click Tracking Domains</h6>
        <li><strong>Google</strong>: <code>https://ad.doubleclick.net</code></li>
        <li><strong>Sizmek</strong>: <code>https://bs.serving-sys.com</code></li>
        <li><strong>Flashtalking</strong>: <code>https://servedby.flashtalking.com</code></li>
        <li><strong>Adform</strong>: <code>https://adform.net</code></li>
      </ul>
      <ul class="p-3">
        <h6>Third-Party Tracking Scripts</h6>
        <li><strong>Adloox</strong>: <code>https://adlooxtracking.com</code></li>
        <li><strong>Integral Ad Science</strong>: <code>https://adsafeprotected.com</code></li>
        <li><strong>DoubleVerify</strong>: <code>https://doubleverify.com</code></li>
        <li><strong>Brand Metrics</strong>: <code>https://brandmetrics.com</code></li>
      </ul>
      <ul class="p-3">
        <h6>Third-Party Image Tracking</h6>
        <li><strong>Nielsen</strong>: <code>https://myvisualiq.net</code></li>
        <li><strong>Kantar</strong>: <code>https://insightexpressai.com</code></li>
        <li><strong>Dynata</strong>: <code>https://researchnow.com</code></li>
        <li><strong>AT Internet</strong>: <code>https://xiti.com</code></li>
      </ul>
      <h6>Domain Not Listed?</h6>
      <p>If your desired tracking domain is not available, please contact our support team at <strong>support@smartology.net</strong>.</p>
      <p>Our team can help you configure custom tracking solutions or add support for additional domains.</p>
    </template>
  </base-help-tooltip>
</template>
<script>
/* eslint-disable no-await-in-loop */
export default {
  name: 'TrackerLabel',
  props: {
    labelName: {
      type: String,
      default: null,
    },
  },
};
</script>
